import Postmate from 'postmate'

export const iframeParentCommunication = {
  methods: {
    InitCommunication (config) {
      window.handshake = new Postmate.Model(config)
    },
    SendMessageToParent (data) {
      window.handshake.then((parent) => {
        parent.emit('eIn_listener', data)
      })
    }
  }
}
